import React, {createContext, ReactNode, useContext} from 'react';

import {ContentItemType} from '@ael/core-api';

interface ContentBlocksProvided {
  inSmallWindow: boolean;
  contentItem: ContentItemType;
}

const ContentBlocksContext = createContext<ContentBlocksProvided>({
  inSmallWindow: false,
  contentItem: null as never as ContentItemType,
});

interface ContentBlocksProviderProps {
  inSmallWindow: boolean;
  contentItem: ContentItemType;
  children?: ReactNode;
}

export const ContentBlocksProvider: React.FC<ContentBlocksProviderProps> = (props) => (
  <ContentBlocksContext.Provider value={{ contentItem: props.contentItem, inSmallWindow: props.inSmallWindow }}>
    {props.children}
  </ContentBlocksContext.Provider>
);

export const useContentBlocksContext = () => useContext(ContentBlocksContext);
